import { useContext, useEffect, useState } from "react"
import { Box, Button } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import RondaEdit from "./RondaEdit"
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { Edit, Delete } from '@mui/icons-material'
import 'jquery-mask-plugin'
import RondaModalDelete from './RondaModalDelete'
import OneTable from "../../../../../Components/OneTable/OneTable"

const ListaRonda = ({ openCadastro, idCentral, setIdToEdit, setOnCloseChanges }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const [listaRonda, setListaRonda] = useState([])
    const [renderizarRonda, setRenderizarRonda] = useState(false)
    const [openDeleteModal, setDeleteModal] = useState(false)
    const [numeroLinha, setNumroLinha] = useState('')
    const [rondaId, setRondaId] = useState('')
    const [editarRonda, setEditarRonda] = useState('')
    const [clickEditRonda, setClickEditRonda] = useState(false)

    useEffect(() => {
        buscaRondaCondominio()
    }, [renderizarRonda])

    useEffect(() => {
        buscaRondaCondominio()
    }, [])

    const getLista = (msg) => {
        const arrayListaRonda = msg.data.listaRonda
        setListaRonda(arrayListaRonda)
    }

    const buscaRondaCondominio = () => {
        sendWs("listaRonda", { idCentral })
        addRoute("listaRonda", getLista)
    }

    const handleClick = () => {
        setRenderizarRonda(true)
    }

    const getRondaEncontrada = (msg) => {
        const arrayListaRonda = msg.data.rondaEncontrada
        const status = msg.data.status

        if (status == true) {
            setEditarRonda(arrayListaRonda)
            setRenderizarRonda(true)
        }
    }

    const rondaComponente = (
        <Grid style={{ width: '100%', height: '100%' }} >
            <RondaEdit
                openCadastro={openCadastro}
                idCentral={idCentral}
                setIdToEdit={setIdToEdit}
                setOnCloseChanges={setOnCloseChanges}
                setRenderizarRonda={setRenderizarRonda}
                rondaEdit={editarRonda}
                clickEditRonda={clickEditRonda}
            />
        </Grid>
    )

    const handleClickDelete = (rondaId, linhaId) => {
        setDeleteModal(true)
        setNumroLinha(linhaId)
        setRondaId(rondaId)
    }

    const handleClickEdit = (rondaId, linhaId) => {
        setClickEditRonda(true)
        sendWs("pegaDadosRondaId", { rondaId })
        addRoute("pegaDadosRondaId", getRondaEncontrada)
    }

    const tableColumns = [
        {
            name: '#',
            selector: row => <RowTable value={((row && row.api && row.api.getRowIndex(row.id) + 1))} />,
            grow: 0.4
        },
        {
            name: 'Ativo',
            selector: row => <RowTable value={(row.ativo ? 'Sim' : 'Não')} style_={(row.ativo ? { color: 'green' } : { color: 'red' })}/>,
            grow: 0.4
        },
        {
            name: 'Hr Ini.',
            selector: row => <RowTable value={row.horario_inicial} />,
            grow: 1.5
        },
        {
            name: 'Hr Fim.',
            selector: row => <RowTable value={row.horario_final} />,
            grow: 1.5
        },
        {
            name: 'Recorrência',
            selector: row => <RowTable value={row.tempo_recorrencia} />,
            grow: 3
        },
        {
            name: 'Ações',
            cell: row => <RowTable value={<AcoesLinha row={row} />} />,
            grow: 2
        }
    ]

    const RowTable = ({ value, style_ = false }) => {
        return (
            (style_ ? <p style={ style_ }>{value}</p> : <p>{value}</p>
            )
        )
    }

    const AcoesLinha = ({ row }) => {
        return (
            <Box style={{ width: '75px', padding: '8px', display: 'flex', justifyContent: 'space-between' }}>
                <Edit style={{ cursor: 'pointer' }} onClick={() => handleClickEdit(row.id, row.id + 1)}/>
                <Delete style={{ cursor: 'pointer' }} onClick={() => handleClickDelete(row.id, row.id + 1)}/>
            </Box>
        )
    }
    const listaRondaTabela = (
        <Grid style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }} >
            {openDeleteModal &&
            <RondaModalDelete
                open={openDeleteModal}
                setOpen={setDeleteModal}
                title={'Excluir Ronda'}
                eventId={numeroLinha}
                rondaId={rondaId}
                setRenderizarRonda={setRenderizarRonda}
            />
            }
            <Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: "center" }} >
                <Box style={{ width: '100%', height: '100%' }} >

                    { listaRonda && listaRonda.length > 0 &&
                        <OneTable
                            columns={tableColumns}
                            data={listaRonda}
                            sx={{ height: '100%' }}
                            // progressPending={!loading}
                            // dobleClickCallback={editEvent}
                        />
                    }
                </Box>
            </Grid>
            <Grid style={{ width: '50%', display: 'flex', justifyContent: 'space-between', padding: '1%' }}>
                <Button variant="contained" color="one_primary" onClick={() => handleClick()}>CRIAR RONDA</Button>
            </Grid>
        </Grid>
    )

    return (
        <Grid style={{ width: '100%' }}>
            {renderizarRonda ? rondaComponente : listaRondaTabela }
        </Grid>
    )
}

export default ListaRonda
